import { useRouter } from "next/router";
import { useContext, useEffect, useRef } from "react";
import { primary } from "../../constants/theme";
import { Context } from "../../context/context";
import Image from "next/image";
import { sendAnalytics } from "../../utils/analyticsCommon";
import styles from "./vehicleMiniCard.module.css";

const VehicleMiniCard = ({ details, id, ctaText, isHindi = false, isKannada = false }) => {
  const { showLoanPopup } = useContext(Context);

  const navigate = useRouter();
  const targetRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.8,
    };

    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;

      if (entry.isIntersecting) {
        sendAnalytics(`v2_scroll_mini_card_${id}`, {}, "en");
      }
    }, options);

    if (targetRef.current) observer.observe(targetRef.current);

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      if (targetRef.current) observer.unobserve(targetRef.current);
    };
  }, [targetRef, id]);

  const handleMiniVehicleCardButton = () => {
    let payload = {
      vehicle_id: details?.id,
      vehicle_name: details?.name,
    };
    sendAnalytics("v2_mini_vehicle_card", payload, "en");

    const loanPayload = {
      brand: details?.brand,
      isPassenger: details?.isPassenger || false,
      formTrigger: "v2_view_vehicle_latest_model",
      vehicle_id: "",
      CTAText: isHindi
        ? details.hindiCTAText
        : isKannada
        ? details?.kannadaCTAText
        : details?.CTAText || "",
      headingText: isHindi
        ? details?.hindiHeadingText
        : isKannada
        ? details?.kannadaHeadingText
        : details?.headingText || "",
    };
    if (details?.isPassenger || details?.isOpenPopUp) {
      showLoanPopup(loanPayload);
    } else {
      if (localStorage?.getItem("phoneInfo") === null) {
        showLoanPopup(loanPayload);
      } else {
        navigate.push(`/electric-commercial-vehicles/${details?.brand}`);
      }
    }
  };

  const renderVehicleMiniCard = () => {
    return (
      <div className={styles?.mainContainer}>
        <div className={styles.leftContainer}>
          <Image
            src={details?.image}
            alt={details?.brand}
            width={190}
            height={190}
            style={{
              // width: details?.brand === "Euler" ? "100%" : "85%",
              // height: "85%",
            }}
          />
        </div>
        <div className={styles.rightContainer}>
          <div className={styles.logo}>
            <Image
              width={190}
              height={190}
              src={details?.logo}
              style={{
                width: "80px",
                height: details?.brand === "Euler" ? "17px" : "auto",
              }}
              alt="details logo"
            />
          </div>
          {details?.range && (
            <div className={styles.topRange}>
              Top Range :{" "}
              <span className={styles.subHeaderInfo}>{details?.range} km</span>
            </div>
          )}
          {details?.emi && (
            <div style={{ fontSize: "12px" }} className={styles.startingEmi}>
              Starting EMI :
              <span
                className={styles.subHeaderInfo}
                style={{ color: primary?.main }}
              >
                {" "}
                ₹{details?.emi}
              </span>{" "}
              / m
            </div>
          )}
          <div className={styles.buttonContainer}>
            <button
              className={styles.button}
              onClick={handleMiniVehicleCardButton}
            >
              {ctaText ? ctaText : `View Gadi`}
            </button>
          </div>
        </div>
      </div>
    );
  };

  return <>{renderVehicleMiniCard()}</>;
};

export default VehicleMiniCard;
